(function () {

    WorkRestrictionsService.$inject = ['ScheduleDataServiceV2', 'businessDayUtils', 'TSUsersService', 'ShiftTemplateUtils'];
    function WorkRestrictionsService(ScheduleDataServiceV2, businessDayUtils, TSUsersService, ShiftTemplateUtils)  {
        var self = this;

        self.PERIOD_TYPES = {
            SCHOOL_DAY: 'SCHOOL_DAY',
            NON_SCHOOL_DAY: 'NON_SCHOOL_DAY',
            HOLIDAY: 'HOLIDAY',
            EXEMPTION_DAY: 'EXEMPTION_DAY'
        };
        
        self.WEEK_SCHOOL_STATUS =  {
            IN_SESSION: 'IN_SESSION',
            NOT_IN_SESSION: 'NOT_IN_SESSION'
        };
        self.RULE_PERIODS_TYPES = {
            WEEK: 'WEEK',
            DAY: 'DAY',
            CUSTOM: 'CUSTOM'
        };
        self.PERIOD_REFERENCE_TYPE = {
            SHIFT_START: 'SHIFT_START',
            SHIFT_END: 'SHIFT_END'
        };
        self.UNIT_TYPE =  {
            DAY: 'DAY',
            HOUR: 'HOUR'
        };
        self.UNIT_VALIDATION_TYPE = {
            WORKING_HOURS: 'WORKING_HOURS',
            WORKING_HOURS_AND_SCHOOL_TIME: 'WORKING_HOURS_AND_SCHOOL_TIME'
        };
        self.WORK_RESTRICTION_VIOLATIONS_TEXT = {
            IN_SCHOOL_TIME: 'Minors shifts overlap with school availability',
            MINOR_EMPLOYEE_EXCEEDS_DAYS_PER_WEEK: 'Minors exceeded their scheduled days per week',
            WORK_VISA_EMPLOYEE_EXCEEDS_DAYS_PER_WEEK: 'Employees with a work visa have exceeded their scheduled days per week',
            MINOR_EMPLOYEE_EXCEEDS_HOURS_PER_WEEK: 'Minors exceeded their scheduled hours per week',
            MINOR_NO_EFFECTIVE_WORK_PERMIT: 'Minors without an active minor work permit',
            WORK_VISA_EMPLOYEE_EXCEEDS_HOURS_PER_WEEK: 'Employees with a work visa have exceeded their scheduled hours per week',
            MINOR_MAX_COMBINED_HOURS_PER_DAY: 'Minors scheduled over maximum combined hours of school and work per day',
            MINOR_MAX_HOURS_PER_DAY: 'Minors exceeded their scheduled hours per day',
            PROHIBITED_HOURS: 'Minors shifts scheduled within the prohibited hours',
            MINOR_EMPLOYEE_NO_EFFECTIVE_SCHOOL_CALENDAR: 'Minors with no school calendar assigned',
            WORK_VISA_NO_EFFECTIVE_SCHOOL_CALENDAR: 'Employees with a work visa with no school calendar assigned',
            MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_PER_WEEK : 'Below the required minimum rest hours per week',
            MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_BETWEEN_SHIFTS: 'Below rest hours between shifts',
        };
        const RULE_STATUS = {
            ACTIVE: 'ACTIVE'
        };
        const UNIT_VALUE_CONTINUITY_TYPE = {
            CONTINUOUS: 'CONTINUOUS'
        };
        const RESTRICTION_TYPE_CONST = {
            EMPLOYEE_EXCEEDS_MIN_REST_HOURS_PER_WEEK: '_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_PER_WEEK',
            MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_BETWEEN_SHIFTS : 'MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_BETWEEN_SHIFTS'
        };

        var MILLISECOND = 1000;
        var HOURS = 3600;
        var DAY = 24 * 60 * 60;

        self.minorUsersSchoolCalenders = {};
        self.workVisasUsersSchoolCalenders = {};
        self.shiftsPerUsers = {};
        self.lastCalenderDayShiftsInPreviousWeekMap = {};

        self.parseSchoolCalenders = function (schoolCalendersData, workRestrictionType) {
            if (workRestrictionType === 'MINOR') {
                self.minorUsersSchoolCalenders = prepareFormattedSchoolCalender(schoolCalendersData);
            }
            else if (workRestrictionType === 'WORK_VISA') {
                self.workVisasUsersSchoolCalenders = prepareFormattedSchoolCalender(schoolCalendersData);
            }
        };

        self.getUserSchoolCalender = function (workRestrictionType, userId) {
            if (workRestrictionType === 'MINOR') {
                return self.minorUsersSchoolCalenders && self.minorUsersSchoolCalenders[userId];
            }
            else if (workRestrictionType === 'WORK_VISA') {
                return self.workVisasUsersSchoolCalenders && self.workVisasUsersSchoolCalenders[userId];
            }
        }

        var prepareFormattedSchoolCalender = function (schoolCalendersData) {
            var usersSchoolCalenders = {};

            for (var i in schoolCalendersData) {
                var schoolCalenderPeriod = schoolCalendersData[i];
                var periodDate = moment(schoolCalenderPeriod.start_datetime, "YYYY-MM-DDTHH:mm:ss");
                var endPeriodDate = moment(schoolCalenderPeriod.end_datetime, "YYYY-MM-DDTHH:mm:ss");
                var periodFormattedDate = periodDate.format("MMM DD, YYYY");

                schoolCalenderPeriod.start_time = schoolCalenderPeriod.start_datetime;
                schoolCalenderPeriod.end_time = schoolCalenderPeriod.end_datetime;

                if (schoolCalenderPeriod.type === self.PERIOD_TYPES.SCHOOL_DAY) {
                    schoolCalenderPeriod.startTime = periodDate.format("hh:mm:ss");
                    schoolCalenderPeriod.endTime = endPeriodDate.format("hh:mm:ss");
                    var duration = moment.duration(endPeriodDate.diff(periodDate));
                    schoolCalenderPeriod.duration = duration.asSeconds();
                }

                usersSchoolCalenders[schoolCalenderPeriod.user_id] = usersSchoolCalenders[schoolCalenderPeriod.user_id] || {};
                usersSchoolCalenders[schoolCalenderPeriod.user_id][periodFormattedDate] = schoolCalenderPeriod;
            }
            return usersSchoolCalenders;
        };

        self.prepareWorkRestrictionsRules = function (workRulesProperties) {
            var ruleProperties = {
                maxHoursPerDay: {},
                maxHoursPerWeek: {},
                maxDaysPerWeek: {},
                shiftsTimes: {},
                maxHoursPerPeriod: {},
                maxCombinedHoursPerDay: {},
                minRestHoursPerWeek: {},
                minRestHoursBetweenShifts: {},
            }

            for (var j in workRulesProperties) {
                var rule = workRulesProperties[j];

                if (rule.week_school_status) {
                    if (rule.unit_type === self.UNIT_TYPE.HOUR) {
                        switch (rule.period_type) {
                            case self.RULE_PERIODS_TYPES.WEEK:
                                if (rule.unit_value_continuity === UNIT_VALUE_CONTINUITY_TYPE.CONTINUOUS) {
                                    ruleProperties['minRestHoursPerWeek'][rule.week_school_status] = rule;
                                } else {
                                    ruleProperties['maxHoursPerWeek'][rule.week_school_status] = rule;
                                }
                                break;
                            case self.RULE_PERIODS_TYPES.CUSTOM:
                                ruleProperties['minRestHoursBetweenShifts'][rule.period_reference_type] = rule;
                                break;
                        }
                    } else {
                        ruleProperties['maxDaysPerWeek'][rule.week_school_status] = ruleProperties['maxDaysPerWeek'][rule.week_school_status] || {};
                        ruleProperties['maxDaysPerWeek'][rule.week_school_status][rule.unit_value_continuity] = rule;
                    }
                } else {
                    var ruleKey = rule.current_period_type + '_' + rule.next_period_type;

                    if (rule['unit_validation_type'] === self.UNIT_VALIDATION_TYPE.WORKING_HOURS_AND_SCHOOL_TIME) {
                        ruleProperties['maxCombinedHoursPerDay'][self.WEEK_SCHOOL_STATUS.IN_SESSION] = rule;
                    } else if (!isNaN(rule.start_time) && !isNaN(rule.end_time)) {
                        ruleProperties['shiftsTimes'][ruleKey] = rule;
                    } else if (!isNaN(rule.unit_value)) {
                        if (rule.period_type ===self.RULE_PERIODS_TYPES.CUSTOM) {
                            ruleProperties['maxHoursPerPeriod'][rule.period_reference_type] = rule;
                        } else {
                            ruleProperties['maxHoursPerDay'][ruleKey] = rule;
                        }

                    }
                }
            }
            return ruleProperties;
        };

        self.checkWeekStatus = function (userSchoolCalender, weekCalenderDays) {
            var isWeekInSession = false;
            var calenderDays = Object.keys(weekCalenderDays);

            for (var i in userSchoolCalender) {
                if (calenderDays.indexOf(i) === -1) {
                    continue;
                }
                if (![self.PERIOD_TYPES.HOLIDAY, self.PERIOD_TYPES.EXEMPTION_DAY].includes(userSchoolCalender[i].type)) {
                    isWeekInSession = true;
                    break;
                }
            }

            return isWeekInSession;
        };

        self.getShiftsMap = (shifts, isAutoAssignEnabled, userId) => {
            var shiftsMap = {};
            for (var i in shifts) {
                var shift = shifts[i];
                if (isAutoAssignEnabled) {
                    shift.user_id = userId;
                }
                if (
                    shift &&
                    shift.user_id &&
                    shift.status !== 'DELETED'
                ) {
                    const shiftDetails = getShiftIntervals(shift);
                    shiftsMap[shift.user_id] = shiftsMap[shift.user_id]  || {shifts: {}}
                    shiftsMap[shift.user_id]['shifts'] = shiftsMap[shift.user_id]['shifts'] || {};
                    shiftsMap[shift.user_id]['shifts'][shift.day] = shiftsMap[shift.user_id]['shifts'][shift.day] || [];

                    var formattedShift = $.extend(shift, {
                        shiftTime: shiftDetails.shiftTime,
                        startTime: shift.start_time,
                        endTime: shift.end_time,
                        shiftDay: shiftDetails.shiftDay,
                    });
                    shiftsMap[shift.user_id]['shifts'][shift.day].push(formattedShift);
                }
            }
            return shiftsMap;
        }

        self.prepareFormattedShiftsMapPerUser = function (startOfWeek, scheduleFlatData, crossLocationFlatData, extraDayFlatData, extraCrossDayFlatData, breaksMap) {
            var sortedShifts = getSortedShifts(scheduleFlatData, crossLocationFlatData);
            var dayBeforeShifts = getBeforeDaySortedShifts(startOfWeek, extraDayFlatData || {}, extraCrossDayFlatData || {});
            var allShifts = dayBeforeShifts.concat(sortedShifts);
            self.shiftsPerUsers = self.getShiftsMap(allShifts);
        };

        self.mapShiftsInLastDayInPreviousWeekForUsers = (extraDayFlatData, extraCrossDayFlatData) => {
            const shifts = {...extraDayFlatData.shifts, ...extraCrossDayFlatData.shifts};
            const usersIds = [...new Set(Object.values(shifts).map(shift => shift.user_id))];
            for (const userId of usersIds) {
                const userShifts = Object.values(shifts)
                    .filter(shift => shift.user_id === userId && moment(shift.end_time).isBefore(moment(ScheduleDataServiceV2.startDate)))
                    .sort((a, b) => moment(a.end_time, 'MMM DD, YYYY HH:mm') - moment(b.end_time, 'MMM DD, YYYY HH:mm'));
                self.lastCalenderDayShiftsInPreviousWeekMap[userId] ??= userShifts;
            }
        };

        self.getEmployeeWorkRestrictionsWarnings = function (rulesSet, usersWork, restrictionType) {
            var weekStatus = usersWork['isWeekInSession'] ?self.WEEK_SCHOOL_STATUS.IN_SESSION :self.WEEK_SCHOOL_STATUS.NOT_IN_SESSION;
            var userWarnings = {};

            if (
                rulesSet['maxDaysPerWeek'] &&
                rulesSet['maxDaysPerWeek'][weekStatus] &&
                rulesSet['maxDaysPerWeek'][weekStatus]['DISCRETE'] &&
                rulesSet['maxDaysPerWeek'][weekStatus]['DISCRETE'].status === "ACTIVE"
            ) {
                var maxDaysPerWeekRule = rulesSet['maxDaysPerWeek'][weekStatus]['DISCRETE'].unit_value;
                var daysPerWeek = Object.keys(usersWork['daysPerWeek']).length;
                if (daysPerWeek > maxDaysPerWeekRule) {
                    userWarnings[restrictionType + '_'+ 'EMPLOYEE_EXCEEDS_DAYS_PER_WEEK'] = {
                        key: restrictionType + '_'+ 'EMPLOYEE_EXCEEDS_DAYS_PER_WEEK',
                        restrictionType: restrictionType,
                        value: maxDaysPerWeekRule
                    };
                }
            }

            if (
                rulesSet['maxHoursPerWeek'] &&
                rulesSet['maxHoursPerWeek'][weekStatus] &&
                rulesSet['maxHoursPerWeek'][weekStatus].status === "ACTIVE"
            ) {
                var maxHoursPerWeekRule = rulesSet['maxHoursPerWeek'][weekStatus].unit_value * HOURS;
                var hoursPerWeek = usersWork['hoursPerWeek'] || 0;

                if (hoursPerWeek > maxHoursPerWeekRule) {

                    userWarnings[restrictionType + '_'+ 'EMPLOYEE_EXCEEDS_HOURS_PER_WEEK'] = {
                        key: restrictionType + '_'+ 'EMPLOYEE_EXCEEDS_HOURS_PER_WEEK',
                        restrictionType: restrictionType,
                        value: maxHoursPerWeekRule
                    };
                }
            }

            if (
                rulesSet['minRestHoursPerWeek'] &&
                rulesSet['minRestHoursPerWeek'][weekStatus] &&
                rulesSet['minRestHoursPerWeek'][weekStatus].status === RULE_STATUS.ACTIVE
            ) {
                let minRestHoursPerWeekRule = rulesSet['minRestHoursPerWeek'][weekStatus].unit_value;
                let maxBreakDurationHours = usersWork['maxBreakDurationHours'];
                if (!isNaN(maxBreakDurationHours) && (maxBreakDurationHours < minRestHoursPerWeekRule)) {
                    userWarnings[restrictionType + RESTRICTION_TYPE_CONST.EMPLOYEE_EXCEEDS_MIN_REST_HOURS_PER_WEEK] = {
                        key: restrictionType + RESTRICTION_TYPE_CONST.EMPLOYEE_EXCEEDS_MIN_REST_HOURS_PER_WEEK,
                        restrictionType: restrictionType,
                        value: minRestHoursPerWeekRule
                    };
                }
            }

            return userWarnings;
        };

        self.getShiftWorkRestrictionsWarnings = function (userSchoolCalender, rulesSet, usersWork, shift) {
            var weekStatus = usersWork['isWeekInSession'] ?self.WEEK_SCHOOL_STATUS.IN_SESSION :self.WEEK_SCHOOL_STATUS.NOT_IN_SESSION;
            var shiftDay = moment(shift.startTime).format('MMM DD, YYYY');
            var dayStatus = userSchoolCalender[shiftDay].type;
            var nextDayDate = moment(shiftDay, 'MMM DD, YYYY').add(1, 'days').format('MMM DD, YYYY');
            var nextDayStatus = userSchoolCalender[nextDayDate] ? userSchoolCalender[nextDayDate].type : self.PERIOD_TYPES.HOLIDAY;
            var shiftRulesWarning = [];

            if (
                rulesSet['maxHoursPerDay'] &&
                dayStatus &&
                nextDayStatus &&
                rulesSet['maxHoursPerDay'][dayStatus + '_' + nextDayStatus] &&
                rulesSet['maxHoursPerDay'][dayStatus + '_' + nextDayStatus].status === "ACTIVE"
            ) {
                var maxHoursPerDayRule = rulesSet['maxHoursPerDay'][dayStatus + '_' + nextDayStatus].unit_value * HOURS;
                var hoursPerDay = usersWork['daysPerWeek'][shiftDay] || 0;

                if (hoursPerDay > maxHoursPerDayRule) {
                    shiftRulesWarning.push({
                        key: 'MINOR_MAX_HOURS_PER_DAY',
                        value: maxHoursPerDayRule
                    });
                }
            }
            if (
                rulesSet['maxCombinedHoursPerDay'] &&
                rulesSet['maxCombinedHoursPerDay'][weekStatus] &&
                rulesSet['maxCombinedHoursPerDay'][weekStatus].status === "ACTIVE" &&
                dayStatus === self.PERIOD_TYPES.SCHOOL_DAY
            ) {
                var maxCombinedHoursPerDayRule = rulesSet['maxCombinedHoursPerDay']['IN_SESSION'].unit_value * HOURS;
                var hoursPerDay = usersWork['daysPerWeek'][shiftDay] || 0;
                var schoolHours = userSchoolCalender[shiftDay].duration || 0;
                if ((hoursPerDay + schoolHours) > maxCombinedHoursPerDayRule) {

                    shiftRulesWarning.push({
                        key: 'MINOR_MAX_COMBINED_HOURS_PER_DAY',
                        value: maxCombinedHoursPerDayRule
                    });
                }
            }

            if (
                rulesSet['maxHoursPerPeriod'] &&
                rulesSet['maxHoursPerPeriod']['SHIFT_END'] &&
                rulesSet['maxHoursPerPeriod']['SHIFT_END'].status === "ACTIVE" &&
                usersWork['rollingHours'] &&
                usersWork['rollingHours'][shift.id] &&
                usersWork['rollingHours'][shift.id] > 0
            ) {
                var maxHoursPerPeriodRule = rulesSet['maxHoursPerPeriod']['SHIFT_END'].unit_value * HOURS;
                var hoursPerPeriod = usersWork['rollingHours'][shift.id];

                if (hoursPerPeriod > maxHoursPerPeriodRule) {
                    shiftRulesWarning.push({
                        key: 'MINOR_ROLLING_24_HOURS',
                        value: maxHoursPerPeriodRule,
                        period_length: Math.abs(rulesSet['maxHoursPerPeriod']['SHIFT_END'].period_length)
                    });
                }

            }

            if (
                rulesSet['shiftsTimes'] &&
                dayStatus &&
                nextDayStatus &&
                rulesSet['shiftsTimes'][dayStatus + '_' + nextDayStatus] &&
                rulesSet['shiftsTimes'][dayStatus + '_' + nextDayStatus].status === "ACTIVE"
            ) {
                var shiftStart = new Date(shift.startTime).getTime();
                var shiftEnd = new Date(shift.endTime).getTime();
                var shiftTimesRule = rulesSet['shiftsTimes'][dayStatus + '_' + nextDayStatus];
                var shiftTimePeriod = ShiftTemplateUtils.getPeriod(shiftTimesRule.start_time, shiftTimesRule.end_time, shiftDay);

                var earliestTime = shiftTimePeriod.start;
                var latestTime = shiftTimePeriod.end;

                if (shiftStart < earliestTime.getTime()) {

                    shiftRulesWarning.push({
                        key: 'PROHIBITED_HOURS',
                        sub_key: 'before_shift_earliest_time',
                        value: shiftTimesRule.start_time,
                        formatted_time: moment(shiftTimePeriod.start).format('hh:mm A')
                    });
                }

                if (
                    shiftStart > latestTime.getTime() ||
                    shiftEnd > latestTime.getTime()
                ) {

                    shiftRulesWarning.push({
                        key: 'PROHIBITED_HOURS',
                        sub_key: 'after_shift_latest_time',
                        value: shiftTimesRule.end_time,
                        formatted_time: moment(shiftTimePeriod.end).format('hh:mm A')
                    });
                }
            }

            if (
                rulesSet?.minRestHoursBetweenShifts?.[self.PERIOD_REFERENCE_TYPE.SHIFT_START]?.status === RULE_STATUS.ACTIVE &&
                rulesSet?.minRestHoursBetweenShifts?.[self.PERIOD_REFERENCE_TYPE.SHIFT_START]?.unit_value > 0
            ) {
                const minRestHoursBetweenShiftsRule = rulesSet['minRestHoursBetweenShifts'][self.PERIOD_REFERENCE_TYPE.SHIFT_START].unit_value;
                const restHoursBetweenShifts = usersWork?.restHours?.[shift.id];
                if (restHoursBetweenShifts && (restHoursBetweenShifts < minRestHoursBetweenShiftsRule)) {
                    shiftRulesWarning.push({
                        key: RESTRICTION_TYPE_CONST.MINOR_EMPLOYEE_EXCEEDS_MIN_REST_HOURS_BETWEEN_SHIFTS,
                        value: minRestHoursBetweenShiftsRule,
                    });
                }
            }

            return shiftRulesWarning;
        };


        self.getFormattedShiftsPerUser = function () {
            return self.shiftsPerUsers;
        }

        self.getCalenderDays = function (startOfWeek) {
            var weekDay = {};

            var startOfCalenderWeek = moment(startOfWeek, 'MMM DD, YYYY');

            for (var i = 0; i < 7; i++) {
                var date = startOfCalenderWeek.clone().add(i, 'days').format('MMM DD, YYYY');
                var dayPeriod = ShiftTemplateUtils.getPeriod(0,86400, date);

                weekDay[date] = {
                    startTime: dayPeriod.start,
                    endTime: dayPeriod.end
                };
            }

            return weekDay;
        };

        const getShiftIntervals = (shift) => {
            const start = new Date(shift.start_time).getTime();
            const end = new Date(shift.end_time).getTime();
            const shiftDay = moment(shift.start_time).format('MMM DD, YYYY');
            const shiftTime = (end - start) / MILLISECOND;

            return {
                shiftDay: shiftDay,
                shiftTime: shiftTime
            }
        };

        var getBeforeDaySortedShifts = function (startOfWeek, extraDayFlatData, extraCrossDayFlatData) {
            // get shifts from day before with same start week date
            var dayBeforeShifts = [];

            for (var s in extraDayFlatData['shifts']) {
                var shift = extraDayFlatData['shifts'][s];

                if (moment(shift.end_time, 'MMM DD, YYYY HH:mm').format('MMM DD, YYYY') === startOfWeek) {
                    dayBeforeShifts.push(shift);
                }
            }

            for (var cs in extraCrossDayFlatData['shifts']) {
                var shift = extraCrossDayFlatData['shifts'][cs];

                if (moment(shift.end_time, 'MMM DD, YYYY HH:mm').format('MMM DD, YYYY') === startOfWeek) {
                    dayBeforeShifts.push(shift);
                }
            }

            var allBeforeDayShifts = _.sortBy(dayBeforeShifts, function (shift) {
                return new Date(shift.start_time).getTime() + "_" + new Date(shift.end_time).getTime();
            });

            return allBeforeDayShifts;
        };

        var getSortedShifts = function (scheduleFlatData, crossLocationFlatData) {
            var allShifts = [];
            // get all shifts from same location
            for (var shiftId in scheduleFlatData['shifts']) {
                allShifts.push(scheduleFlatData['shifts'][shiftId]);
            }
            // get all cross location shifts
            for (var brand in crossLocationFlatData) {
                for (var ext in crossLocationFlatData[brand]['shifts']) {
                    allShifts.push(crossLocationFlatData[brand]['shifts'][ext]);
                }
            }

            var sortedShifts = _.sortBy(allShifts, function (shift) {
                if (shift) {
                    var position_code = shift['cross_location']? crossLocationFlatData[shift.brand_id]['roles'][shift.role_id].position.code: scheduleFlatData['roles'][shift.role_id].position.code;
                    return new Date(shift.start_time).getTime() + "_" + new Date(shift.end_time).getTime() + "_" + position_code;
                }
            });

            return sortedShifts;
        };

        self.reset = function () {
            self.minorUsersSchoolCalenders = {};
            self.workVisasUsersSchoolCalenders = {};
            self.shiftsPerUsers = {};
            self.lastCalenderDayShiftsInPreviousWeekMap = {};
        }
    }
    app.service('workRestrictionsService', WorkRestrictionsService);

}());